var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "IndexForm",
    { attrs: { "is-whitelabel": _vm.isWhitelabel } },
    [
      _vm.brpDetails
        ? _c("BuyerRegistrationPageForm", {
            attrs: {
              "action-status": _vm.actionStatus,
              "brp-details": _vm.brpDetails
            },
            on: { "on-register": _vm.onSubmit }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.brpDetails
        ? _c("OpenRegistrationPageError", {
            attrs: { "applicant-type": "buyer" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }